import mediator from "@tvg/mediator";
import {
  AccountPanelNavigation,
  EventProps,
  MediatorEventType,
  ModalCTA,
  Payload,
  ViewOnboardModal,
  ViewWelcomeModal
} from "./types";
import { track } from "../../amplitude";
import { BaseEventProps } from "../../types";
import { EVENT_NAME } from "./constants";

export default () => {
  mediator.base.subscribe(
    MediatorEventType.ONBOARDING_VIEW,
    ({ payload }: Payload<ViewOnboardModal>) => {
      const { betaFeature } = payload;
      track<BaseEventProps>(EVENT_NAME.TRY_NOW_MODAL_VIEWED, {
        [BaseEventProps.EVENT_CATEGORY]: "Beta Onboarding",
        [BaseEventProps.EVENT_LABEL]: betaFeature,
        [BaseEventProps.MODULE]: betaFeature + " Try Now Modal"
      });
    }
  );

  mediator.base.subscribe(
    MediatorEventType.ONBOARD_CTA,
    ({ payload }: Payload<ModalCTA>) => {
      const { eventLabel } = payload;
      track<BaseEventProps>(EVENT_NAME.TRY_MODAL_CTA_CLICKED, {
        [BaseEventProps.EVENT_CATEGORY]: "Beta Onboarding",
        [BaseEventProps.EVENT_LABEL]: eventLabel,
        [BaseEventProps.MODULE]: "Program Page Try Now Modal"
      });
    }
  );

  mediator.base.subscribe(MediatorEventType.EXIT_VIEW, () => {
    track<BaseEventProps>(EVENT_NAME.EXIT_MODAL_VIEWED, {
      [BaseEventProps.EVENT_CATEGORY]: "Beta Onboarding",
      [BaseEventProps.EVENT_LABEL]: "Program Page",
      [BaseEventProps.MODULE]: "Program Page Exit Modal"
    });
  });

  mediator.base.subscribe(
    MediatorEventType.EXIT_CTA,
    ({ payload }: Payload<ModalCTA>) => {
      const { eventLabel } = payload;
      track<BaseEventProps>(EVENT_NAME.EXIT_MODAL_CTA_CLICKED, {
        [BaseEventProps.EVENT_CATEGORY]: "Beta Onboarding",
        [BaseEventProps.EVENT_LABEL]: eventLabel,
        [BaseEventProps.MODULE]: "Program Page Exit Modal"
      });
    }
  );

  mediator.base.subscribe(MediatorEventType.LEARN_MORE_VIEW, () => {
    track<BaseEventProps>(EVENT_NAME.WHATS_NEW_MODAL_VIEWED, {
      [BaseEventProps.EVENT_CATEGORY]: "Beta Onboarding",
      [BaseEventProps.EVENT_LABEL]: "Program Page",
      [BaseEventProps.MODULE]: "Program Page Whats New Modal"
    });
  });

  mediator.base.subscribe(
    MediatorEventType.LEARN_MORE_CTA,
    ({ payload }: Payload<ModalCTA>) => {
      const { eventLabel } = payload;
      track<BaseEventProps>(EVENT_NAME.WHATS_NEW_MODAL_CTA_CLICKED, {
        [BaseEventProps.EVENT_CATEGORY]: "Beta Onboarding",
        [BaseEventProps.EVENT_LABEL]: eventLabel,
        [BaseEventProps.MODULE]: "Program Page Whats New Modal"
      });
    }
  );

  mediator.base.subscribe(MediatorEventType.FEEDBACK_OPEN, () => {
    track<BaseEventProps>(EVENT_NAME.FEEDBACK_WIDGET_OPENED, {
      [BaseEventProps.EVENT_CATEGORY]: "Beta Onboarding",
      [BaseEventProps.EVENT_LABEL]: "Program Page",
      [BaseEventProps.MODULE]: "Program Page Feedback Widget"
    });
  });

  mediator.base.subscribe(MediatorEventType.FEEDBACK_SUBMIT, () => {
    track<BaseEventProps>(EVENT_NAME.FEEDBACK_WIDGET_SUBMITTED, {
      [BaseEventProps.EVENT_CATEGORY]: "Beta Onboarding",
      [BaseEventProps.EVENT_LABEL]: "Program Page",
      [BaseEventProps.MODULE]: "Program Page Feedback Widget"
    });
  });

  mediator.base.subscribe(
    MediatorEventType.ACCOUNT_PANEL_LINK,
    ({ payload }: Payload<AccountPanelNavigation>) => {
      const { eventLabel, destinationUrl } = payload;
      track<EventProps>(EVENT_NAME.ACCOUNT_PANEL_LINK_CLICKED, {
        [BaseEventProps.EVENT_CATEGORY]: "Navigation",
        [BaseEventProps.LINK_TEXT]: eventLabel,
        [BaseEventProps.MODULE]: "Account Panel",
        [BaseEventProps.LINK_URL]: destinationUrl
      });
    }
  );

  mediator.base.subscribe(
    MediatorEventType.WELCOME_VIEW,
    ({ payload }: Payload<ViewWelcomeModal>) => {
      const { betaFeature } = payload;
      track<BaseEventProps>(EVENT_NAME.WELCOME_MODAL_VIEWED, {
        [BaseEventProps.EVENT_CATEGORY]: "Beta Onboarding",
        [BaseEventProps.EVENT_LABEL]: betaFeature,
        [BaseEventProps.MODULE]: "Program Page Welcome Modal"
      });
    }
  );

  mediator.base.subscribe(MediatorEventType.LETS_START_CTA, () => {
    track<BaseEventProps>(EVENT_NAME.WELCOME_MODAL_CTA_CLICKED, {
      [BaseEventProps.EVENT_CATEGORY]: "Beta Onboarding",
      [BaseEventProps.EVENT_LABEL]: "Let's Start",
      [BaseEventProps.MODULE]: "Program Page Welcome Modal"
    });
  });
};
